import "@unocss/reset/tailwind.css";
import "./index.css";
import Layout from "@/components/Layout";
import {VideoPreloaderProvider} from "@/contexts/VideoPreloaderContext";
import {PRIORITY_VIDEOS} from "@/config/videos";

export function App() {
    return (
        <Layout/>
    );
}

export default App;
